import React from 'react';
import PropTypes from 'prop-types';
import { Table, Tag } from 'antd';
import { RESERVE_STATE } from './../../constants/reserve';
import './styles.css';

const { Column } = Table;

const ReservationsByUserTableAdmin = ({ data, restaurants }) => {

    const getColorTagType = type => {   
        switch (type) {
            case RESERVE_STATE.accepted:
                return 'geekblue';
            case RESERVE_STATE.pending:
                return 'purple';
            case RESERVE_STATE.cancelled:
                return 'volcano';
            case RESERVE_STATE.assisted:
                return 'green';
            case RESERVE_STATE.no_assisted:
                return 'red';
            case RESERVE_STATE.rejected:
                return 'magenta';
            default:
                return;
        }
    };

    const getTagName = type => {   
        switch (type) {
            case RESERVE_STATE.accepted:
                return 'ACEPTADA';
            case RESERVE_STATE.pending:
                return 'PENDIENTE';
            case RESERVE_STATE.cancelled:
                return 'CANCELADA';
            case RESERVE_STATE.assisted:
                return 'ASISTIDA';
            case RESERVE_STATE.no_assisted:
                return 'NO ASISTIDA';
            case RESERVE_STATE.rejected:
                return 'RECHAZADA';
            default:
                return;
        }
    };

    return (
        <Table className="reservationsByUserTableAdminCont" dataSource={data} rowKey="reservationId" size="small" pagination={true}>
            <Column title="Fecha" dataIndex="date" key="date" align="center" />
            <Column title="Hora" dataIndex="hour" key="hour" align="center" />
            <Column title="Cantidad de personas" dataIndex="peopleCount" key="peopleCount" align="center" />
            <Column title="Nombre del restaurante" dataIndex="restoName" key="restoName" align="center"
                filters={restaurants} 
                onFilter= {(value, record) => record.restoId === value} 
            />
            <Column title="Estado" dataIndex="state" key="state" align="center" 
                filters={[ {text: `${getTagName(RESERVE_STATE.accepted)}`, value: `${RESERVE_STATE.accepted}`}, {text: `${getTagName(RESERVE_STATE.pending)}`, value: `${RESERVE_STATE.pending}`}, {text: `${getTagName(RESERVE_STATE.cancelled)}`, value: `${RESERVE_STATE.cancelled}`}, {text: `${getTagName(RESERVE_STATE.assisted)}`, value: `${RESERVE_STATE.assisted}`}, {text: `${getTagName(RESERVE_STATE.no_assisted)}`, value: `${RESERVE_STATE.no_assisted}`}, {text: `${getTagName(RESERVE_STATE.rejected)}`, value: `${RESERVE_STATE.rejected}`} ]} 
                onFilter= {(value, record) => record.state === value}
                render={state => (
                    <span>
                        {<Tag color={getColorTagType(state)} key={state}>
                            {getTagName(state)}
                        </Tag>}
                    </span>
                )}
            />
        </Table>
    );
};

ReservationsByUserTableAdmin.propTypes = {
    data: PropTypes.array.isRequired,
};

export default ReservationsByUserTableAdmin;